export default __webpack_public_path__ + "locales/nl/EmbeddingPanel.json?hash=7e267dd50b07ac7cb2e99ebd3d393c6a";